import countryCodes from './countryCodes.json';

export default {
  methods: {
    getCountryByCode(countryCode) {
      return countryCodes.filter(country => country.code === countryCode)[0];
    },

    getCountryFromPhoneNumber(number) {
      const filter = number[0] === '+' ? number : `+${number}`;
      return countryCodes.filter(country => filter.startsWith(country.dial_code))[0];
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/countries/countryCodesMixin.js